import {Directive, Input, TemplateRef} from '@angular/core';

@Directive({
    selector: '[section]'
})
export class SectionDirective {
    @Input() type?: string;
    @Input('section') name?: string;

    constructor(public template: TemplateRef<any>) {}

    getType(): string {
        return this.name ?? '';
    }
}
